import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_5 = { class: "treatment-record-form" }
const _hoisted_6 = { class: "treatment-record-form-item" }
const _hoisted_7 = { class: "treatment-record-form-label" }
const _hoisted_8 = { for: "disease-name" }
const _hoisted_9 = { class: "treatment-record-form-description" }
const _hoisted_10 = ["value", "selected"]
const _hoisted_11 = {
  key: 1,
  value: ""
}
const _hoisted_12 = {
  key: 0,
  class: "input-required-error active"
}
const _hoisted_13 = { class: "treatment-record-form-label" }
const _hoisted_14 = { for: "disease-name" }
const _hoisted_15 = {
  key: 0,
  class: "treatment-record-form-recorded"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "treatment-record-form-item" }
const _hoisted_18 = { class: "treatment-record-form-label" }
const _hoisted_19 = { for: "treatment-name" }
const _hoisted_20 = { class: "treatment-record-form-description" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  value: null,
  disabled: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "treatment-record-form-label" }
const _hoisted_25 = { for: "treatment-name" }
const _hoisted_26 = { class: "treatment-record-form-recorded" }
const _hoisted_27 = { class: "treatment-record-form-item" }
const _hoisted_28 = { class: "treatment-record-form-label" }
const _hoisted_29 = { for: "treatment-detail" }
const _hoisted_30 = { class: "treatment-record-form-item" }
const _hoisted_31 = { class: "treatment-record-form-label" }
const _hoisted_32 = { for: "treatment-effect" }
const _hoisted_33 = {
  value: null,
  disabled: ""
}
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "treatment-record-form-item" }
const _hoisted_36 = { class: "treatment-record-form-label" }
const _hoisted_37 = { class: "treatment-record-form-label" }
const _hoisted_38 = { class: "treatment-record-form-description" }
const _hoisted_39 = { class: "treatment-record-form-date-container" }
const _hoisted_40 = { class: "treatment-record-form-date-container-year" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "treatment-record-form-date-container-month" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "treatment-record-form-date-container-day" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "treatment-record-form-warning" }
const _hoisted_47 = { class: "treatment-record-form-item" }
const _hoisted_48 = { class: "treatment-record-form-label" }
const _hoisted_49 = { for: "treatment-status" }
const _hoisted_50 = {
  value: null,
  disabled: ""
}
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "treatment-record-form-label" }
const _hoisted_53 = { class: "treatment-record-form-label" }
const _hoisted_54 = { class: "treatment-record-form-description" }
const _hoisted_55 = { class: "treatment-record-form-date-container" }
const _hoisted_56 = { class: "treatment-record-form-date-container-year" }
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "treatment-record-form-date-container-month" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "treatment-record-form-date-container-day" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "treatment-record-form-label" }
const _hoisted_63 = { for: "treatment-reason" }
const _hoisted_64 = {
  key: 0,
  class: "treatment-record-form-delete"
}
const _hoisted_65 = { class: "modal-footer" }
const _hoisted_66 = { class: "modal-footer-buttons" }

import dayjs from "dayjs";
import "dayjs/locale/ja";

import {
  onMounted,
  computed,
  ref,
  reactive,
  toRefs,
  watch,
  getCurrentInstance,
} from "vue";
import { processing, processend } from "@/utils/view";
import { _$t } from "@/utils/i18n";

import { Treatment } from "@/models/myRecord/treatment";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import ConfirmDialog from "@/views/base/CommonMessage.vue";
import CharCounterTextArea from "@/views/base/CharCounterTextArea.vue";

// 日付のローカライズ
type Disease = {
  id: string;
  name: string;
};

type MastOption = {
  id: string;
  label: string;
  value: number;
};

type SelectedTreatmentIds = {
  userTreatmentId: number;
  subNumber: number;
};

type DateOptions = {
  year: string;
  month: string;
  day: string;
};

// ---- props ----------------------------------------
const componentId = "healthcaredata02-02-modal";

// モーダルタイトル

export default /*@__PURE__*/_defineComponent({
  __name: 'TreatmentAddEdit',
  props: {
    diseaseOptions: {},
    selectedTreatmentIds: { default: null }
  },
  emits: ["close", "fetch-treatments"],
  setup(__props: any, { emit: __emit }) {

dayjs.locale("ja");

const props = __props;

// ---- Constants & Variables ------------------------------
const isError = ref(false);
const fieldErrors = ref<Record<string, string>>({});
const sessionErr = ref(false);
const isInitialized = ref(false);

// コンポーネントID
const title =
  props?.selectedTreatmentIds === null
    ? `${_$t("treatment_title_add")}`
    : `${_$t("treatment_title_edit")}`;

const historyId = ref<number>();
// 選択肢
const { diseaseOptions } = toRefs(props);
const effectOptions = ref<MastOption[]>([]);
const treatmentOptions = ref<MastOption[]>([]);
const statusOptions = ref<MastOption[]>([]);
const hasExistingTreatment = ref<boolean>(false);
const isCheckingTreatment = ref(false);
let checkRequestId = 0;

// 選択値
const selectedDisease = ref<string>("");
const selectedEffect = ref<number | null>(null);
const selectedTreatmentOption = ref<number | null>(null);
const selectedStatus = ref<number | null>(null);
const inputDetail = ref<string>("");
const inputBurdenOfMedicine = ref<string>("");
const initialDateObj = {
  year: "",
  month: "",
  day: "",
};
const selectedStartDate = reactive<DateOptions>({ ...initialDateObj });
const selectedUpdateDate = reactive<DateOptions>({ ...initialDateObj });

// ▼ トースト表示用
const { appContext } = getCurrentInstance()!;
const $toast = appContext.config.globalProperties.$toast;

// --- Computed properties for date selection ---

// 年の選択肢
const yearOptions = computed(() => {
  const currentYear = dayjs().year();
  const years = [];
  for (let i = currentYear + 1; i >= 1980; i--) {
    years.push(i);
  }
  return years;
});

// 月の選択肢
const monthOptions = computed(() => {
  return Array.from({ length: 12 }, (_, i) => i + 1);
});

// 日の選択肢（選択された年月に応じて動的に変更）
const getDaysOptions = (year: string, month: string) => {
  if (!year || !month) {
    // 年月が選択されていない場合は31日まで表示
    return Array.from({ length: 31 }, (_, i) => i + 1);
  }

  // その月の最終日を取得
  const daysInMonth = dayjs(`${year}-${month}-01`).daysInMonth();

  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
};

// 治療開始日の選択肢
const startDayOptions = computed(() =>
  getDaysOptions(selectedStartDate.year, selectedStartDate.month)
);

// 日付の選択肢
const updateDayOptions = computed(() =>
  getDaysOptions(selectedUpdateDate.year, selectedUpdateDate.month)
);

// 既存治療がある場合は「なし」オプションを非表示
const filteredTreatmentOptions = computed(() => {
  if (hasExistingTreatment.value) {
    return treatmentOptions.value.filter(
      (option) => option.label !== "治療をしていない"
    );
  }
  return treatmentOptions.value;
});

const emit = __emit;

// --- Dialogs -------------------------------------------

// 確認ダイアログ関連情報
let confirmDialogSet = reactive({
  show: false,
  okButtonHide: true,
  okButton: true,
  okName: _$t("hospital_visit_button_ok"),
  cancelButton: true,
  cancelName: _$t("hospital_visit_button_cancel"),
  message: "", // 表示メッセージ
  open: (message: string): void => {
    processing();
    confirmDialogSet.message = message;
    confirmDialogSet.show = true;
  },
  execute: async (): Promise<void> => {
    processend();
    confirmDialogSet.show = false;
    confirmDialogSet.message = "";
    await deleteData();
    emit("close"); // 削除後は閉じる
    emit("fetch-treatments"); // 削除後はデータ取得
  },
  close: (): void => {
    processend();
    confirmDialogSet.show = false;
  },
});

// エラーダイアログ関連情報
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Functions -------------------------------------------

// 保存処理
async function save() {
  // ## リクエストパラメータの生成 ##############################
  const startDate =
    selectedStartDate.year && selectedStartDate.month && selectedStartDate.day
      ? `${selectedStartDate.year}/${String(selectedStartDate.month).padStart(
        2,
        "0"
      )}/${String(selectedStartDate.day).padStart(2, "0")}`
      : "";
  const updateDate =
    selectedUpdateDate.year &&
    selectedUpdateDate.month &&
    selectedUpdateDate.day
      ? `${selectedUpdateDate.year}/${String(selectedUpdateDate.month).padStart(
        2,
        "0"
      )}/${String(selectedUpdateDate.day).padStart(2, "0")}`
      : "";
  const params: Record<string, any> = {};
  if (props.selectedTreatmentIds)
    params.userTreatmentId = props.selectedTreatmentIds.userTreatmentId;
  if (historyId.value) params.historyId = historyId.value;
  if (inputDetail.value) params.detail = inputDetail.value;
  if (inputBurdenOfMedicine.value) params.burden = inputBurdenOfMedicine.value;
  if (selectedDisease.value) params.diseaseCode = selectedDisease.value;
  if (selectedEffect.value) params.effectOptionId = selectedEffect.value;
  if (selectedTreatmentOption.value)
    params.treatmentOptionId = selectedTreatmentOption.value;
  if (selectedStatus.value) params.statusOptionId = selectedStatus.value;
  if (startDate) params.startDate = startDate;
  if (updateDate) params.updateDate = updateDate;

  // 治療モデルの生成
  const treatment = new Treatment();
  treatment.set(params);

  // ## バリデーションチェック #################################
  let validateResult = treatment.validate();
  fieldErrors.value = {};

  if (!validateResult.valid) {
    validateResult.errors.forEach((error: any) => {
      fieldErrors.value[error.key] = error.msg;
    });
  }

  if (Object.keys(fieldErrors.value).length > 0) {
    isError.value = true;
    return;
  }

  // ## 保存処理 #################################
  const [_model, _response, err] = await treatment.save();

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // 完了メッセージ表示
  $toast({
    message: `${_$t("treatment_title")}${_$t("common_message_saved")}`,
    icon: "success",
  });
  onClose();
  emit("fetch-treatments");
}

// 削除処理
async function deleteData() {
  if (!props.selectedTreatmentIds?.userTreatmentId) {
    return;
  }
  // 病院受診モデルの生成
  const treatment = new Treatment();
  const [_model, _response, err] = await treatment.delete(
    props.selectedTreatmentIds.userTreatmentId
  );

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // 完了メッセージ表示
  $toast({
    message: `${_$t("treatment_title")}${_$t("common_message_delete")}`,
    icon: "success",
  });
  onClose();
  emit("fetch-treatments");
}

const formatOptions = (option: any, index: number): MastOption => ({
  id: `${option.kubun}_${index + 1}`,
  value: option.option_id,
  label: option.display_name,
});

// 初期設定
async function set() {
  // 病院受診モデルの生成
  const treatment = new Treatment();
  const [model, _response, err] = await treatment.getData(
    props?.selectedTreatmentIds
  );

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  const res = _response.data;
  // 選択肢の設定
  effectOptions.value = res.effectOptions.map(formatOptions);
  treatmentOptions.value = res.treatmentOptions.map(formatOptions);
  statusOptions.value = res.statusOptions.map(formatOptions);
  selectedDisease.value = diseaseOptions.value.length
    ? diseaseOptions.value[0].id
    : "";

  const treatmentRes = res.treatment;
  if (treatmentRes) {
    historyId.value = treatmentRes.history_id;
    selectedDisease.value = treatmentRes.disease_code;
    selectedTreatmentOption.value = treatmentRes.treatment_option_id;
    selectedEffect.value = treatmentRes.treatment_effect_option_id;
    selectedStatus.value = treatmentRes.treatment_status_option_id;
    inputDetail.value = treatmentRes.treatment_detail;
    inputBurdenOfMedicine.value = treatmentRes?.burden_of_medicine ?? "";
    if (treatmentRes.treatment_start_date) {
      const [year, month, day] = treatmentRes.treatment_start_date.split("-");
      selectedStartDate.year = year;
      selectedStartDate.month = month;
      selectedStartDate.day = day;
    }
    if (treatmentRes.resume_date) {
      const [year, month, day] = treatmentRes.resume_date.split("-");
      selectedUpdateDate.year = year;
      selectedUpdateDate.month = month;
      selectedUpdateDate.day = day;
    }
  }
}

// 治療対象の病気を変更する際の既存治療チェック
async function checkDiseaseTreatments(diseaseCode: string) {
  if (!diseaseCode) {
    isCheckingTreatment.value = false;
    hasExistingTreatment.value = false;
    return;
  }

  const currentRequestId = ++checkRequestId;
  isCheckingTreatment.value = true;

  try {
    const treatment = new Treatment();
    const [_model, _response, err] = await treatment.checkDiseaseTreatment(
      diseaseCode
    );

    // 古いリクエストのレスポンスは無視
    if (currentRequestId !== checkRequestId) {
      return;
    }

    if (err) {
      hasExistingTreatment.value = false;
      const status = err.error.response.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialogSet.open(decodedMessage);
      return;
    }

    hasExistingTreatment.value = _response.data.hasTreatments;
  } finally {
    // 最新リクエストの場合のみdisabledを解除（古いリクエストは無視）
    if (currentRequestId === checkRequestId) {
      isCheckingTreatment.value = false;
    }
  }
}

// --- Event handlers --------------------------------------------
watch(selectedDisease, (newVal) => {
  if (props?.selectedTreatmentIds) return;

  // 即座にセレクトを無効化する
  if (newVal) {
    isCheckingTreatment.value = true;
  }

  checkDiseaseTreatments(newVal);
});

// 閉じるボタン押下時処理
function onClose() {
  emit("close");
}

// 保存ボタン押下時処理
async function onSave() {
  await save();
}

// 削除ボタン押下時処理
async function onDelete() {
  confirmDialogSet.open(_$t("hospital_visit_message_delete_confirm"));
}

// --- Vue lifecycle --------------------------------------------
onMounted(async () => {
  // 初期設定
  await set();
  isInitialized.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("body", null, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
        _createElementVNode("div", {
          class: "modal modal-treatment-record-add",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": `${componentId}-title`
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "modal-header-title",
              id: `${componentId}-title`
            }, _toDisplayString(_unref(title)), 9, _hoisted_3),
            _createElementVNode("button", {
              class: "modal-close",
              "aria-label": "Close modal",
              onClick: onClose
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
            ]))
          ]),
          (isInitialized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!props?.selectedTreatmentIds)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("label", _hoisted_8, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_disease_name")), 1),
                              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "treatment-record-form-label-required" }, "※", -1))
                            ]),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("treatment_label_disease_name_info")), 1)
                          ]),
                          _withDirectives(_createElementVNode("select", {
                            name: "disease-name",
                            class: "treatment-record-form-disease-name-select",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDisease).value = $event))
                          }, [
                            (_unref(diseaseOptions).length)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(diseaseOptions), (disease, i) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: disease.id,
                                    key: disease.id,
                                    selected: !selectedDisease.value && i == 0
                                  }, _toDisplayString(disease.name), 9, _hoisted_10))
                                }), 128))
                              : (_openBlock(), _createElementBlock("option", _hoisted_11, _toDisplayString(_ctx.$t("treatment_select_option_no_diseases")), 1))
                          ], 512), [
                            [_vModelSelect, selectedDisease.value]
                          ]),
                          (fieldErrors.value.diseaseCode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(fieldErrors.value.diseaseCode), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_disease_name")), 1)
                            ])
                          ]),
                          (selectedDisease.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(diseaseOptions).find((d) => d.id === selectedDisease.value)?.name), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("treatment_select_option_no_diseases")), 1))
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (!props?.selectedTreatmentIds)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("label", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_treatment")), 1),
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "treatment-record-form-label-required" }, "※", -1))
                            ]),
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("treatment_label_treatment_info")), 1)
                          ]),
                          _withDirectives(_createElementVNode("select", {
                            name: "treatment-name",
                            class: "treatment-record-form-treatment-name-select",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTreatmentOption).value = $event)),
                            disabled: isCheckingTreatment.value
                          }, [
                            _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("treatment_select_option_select")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTreatmentOptions.value, (treatment) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: treatment.value,
                                key: treatment.id
                              }, _toDisplayString(treatment.label), 9, _hoisted_23))
                            }), 128))
                          ], 8, _hoisted_21), [
                            [_vModelSelect, selectedTreatmentOption.value]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["input-required-error", { active: fieldErrors.value.treatmentOptionId }])
                          }, _toDisplayString(fieldErrors.value.treatmentOptionId), 3)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("label", _hoisted_25, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_treatment")), 1)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_26, _toDisplayString(treatmentOptions.value.find(
                      (t) => t.value === selectedTreatmentOption.value
                    )?.label), 1)
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_details")), 1)
                      ])
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "treatment-detail",
                      class: "treatment-record-form-treatment-detail-input",
                      placeholder: "例：歩行のリハビリ",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputDetail).value = $event))
                    }, null, 512), [
                      [_vModelText, inputDetail.value]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", { active: fieldErrors.value.detail }])
                    }, _toDisplayString(fieldErrors.value.detail), 3)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_treatment_effect")), 1)
                      ])
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      name: "treatment-effect",
                      class: "treatment-record-form-treatment-effect-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedEffect).value = $event))
                    }, [
                      _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t("treatment_select_option_select")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectOptions.value, (effect) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: effect.value,
                          key: effect.id
                        }, _toDisplayString(effect.label), 9, _hoisted_34))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedEffect.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_start_date")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("treatment_label_start_date_info")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("select", {
                          name: "treatment-start-date-year",
                          class: "treatment-record-form-date-select",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedStartDate.year) = $event))
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "----", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: year,
                              key: year
                            }, _toDisplayString(year), 9, _hoisted_41))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedStartDate.year]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_year")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("select", {
                          name: "treatment-start-date-month",
                          class: "treatment-record-form-date-select",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedStartDate.month) = $event))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthOptions.value, (month) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: month,
                              key: month
                            }, _toDisplayString(month), 9, _hoisted_43))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedStartDate.month]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_month")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("select", {
                          name: "treatment-start-date-day",
                          class: "treatment-record-form-date-select",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedStartDate.day) = $event))
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("option", {
                            value: "",
                            selected: "",
                            disabled: ""
                          }, "--", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startDayOptions.value, (day) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: day,
                              key: day
                            }, _toDisplayString(day), 9, _hoisted_45))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedStartDate.day]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_day")), 1)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("treatment_label_start_date_warning")), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", { active: fieldErrors.value.startDate }])
                    }, _toDisplayString(fieldErrors.value.startDate), 3)
                  ]),
                  (props.selectedTreatmentIds)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", _hoisted_49, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_status")), 1)
                            ])
                          ]),
                          _withDirectives(_createElementVNode("select", {
                            name: "treatment-status",
                            class: "treatment-record-form-treatment-status-select",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedStatus).value = $event))
                          }, [
                            _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t("treatment_select_option_select")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOptions.value, (status) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: status.value,
                                key: status.id
                              }, _toDisplayString(status.label), 9, _hoisted_51))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, selectedStatus.value]
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["treatment-record-form-item", { 'is-disabled': !selectedStatus.value }])
                        }, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_date")), 1)
                            ]),
                            _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t("treatment_label_date_info")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _withDirectives(_createElementVNode("select", {
                                name: "treatment-change-date-year",
                                class: "treatment-record-form-date-select",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedUpdateDate.year) = $event))
                              }, [
                                _cache[18] || (_cache[18] = _createElementVNode("option", {
                                  value: "",
                                  selected: "",
                                  disabled: ""
                                }, "----", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: year,
                                    key: year
                                  }, _toDisplayString(year), 9, _hoisted_57))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedUpdateDate.year]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_year")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _withDirectives(_createElementVNode("select", {
                                name: "treatment-change-date-month",
                                class: "treatment-record-form-date-select",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedUpdateDate.month) = $event))
                              }, [
                                _cache[19] || (_cache[19] = _createElementVNode("option", {
                                  value: "",
                                  selected: "",
                                  disabled: ""
                                }, "--", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthOptions.value, (month) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: month,
                                    key: month
                                  }, _toDisplayString(month), 9, _hoisted_59))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedUpdateDate.month]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_month")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _withDirectives(_createElementVNode("select", {
                                name: "treatment-change-date-day",
                                class: "treatment-record-form-date-select",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedUpdateDate.day) = $event))
                              }, [
                                _cache[20] || (_cache[20] = _createElementVNode("option", {
                                  value: "",
                                  selected: "",
                                  disabled: ""
                                }, "--", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updateDayOptions.value, (day) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: day,
                                    key: day
                                  }, _toDisplayString(day), 9, _hoisted_61))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedUpdateDate.day]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_day")), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["input-required-error", { active: fieldErrors.value.updateDate }])
                          }, _toDisplayString(fieldErrors.value.updateDate), 3)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["treatment-record-form-item", { 'is-disabled': !selectedStatus.value }])
                        }, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_label_reason")), 1)
                            ])
                          ]),
                          _createVNode(CharCounterTextArea, {
                            modelValue: inputBurdenOfMedicine.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inputBurdenOfMedicine).value = $event)),
                            maxlength: 200,
                            placeholder: _unref(_$t)('treatment_placeholder_reason'),
                            "custom-textarea-wrapper": "treatment-record-form-reason-container",
                            "textarea-class": "treatment-record-form-reason-textarea",
                            "char-counter-class": "treatment-record-form-reason-textarea-count"
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["input-required-error", { active: fieldErrors.value.burden }])
                          }, _toDisplayString(fieldErrors.value.burden), 3)
                        ], 2)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (props.selectedTreatmentIds)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "treatment-record-form-delete-button",
                        onClick: onDelete
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", { src: "/server/necs/images/icon_delete_hospital_visit.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_button_delete")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                class: "modal-cansel",
                onClick: onClose
              }, _toDisplayString(_ctx.$t("hospital_visit_button_cancel")), 1),
              _createElementVNode("button", {
                class: "modal-ok",
                onClick: onSave
              }, _toDisplayString(_ctx.$t("treatment_button_save")), 1)
            ])
          ])
        ], 8, _hoisted_1)
      ])
    ]),
    (_unref(errorDialogSet).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialogSet), {
          onOk: _unref(errorDialogSet).close,
          onCancel: _unref(errorDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (_unref(confirmDialogSet).show)
      ? (_openBlock(), _createBlock(ConfirmDialog, _mergeProps({ key: 1 }, _unref(confirmDialogSet), {
          onOk: _unref(confirmDialogSet).execute,
          onCancel: _unref(confirmDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})